var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7D3B2CB3-C392-45FA-AF47-1A2A92470991") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-111.000000, -1658.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Columns",
    transform: "translate(111.000000, 1658.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 20,
    fill: "#6F6F6F"
  }, "Lorem ipsum")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-Copy-5",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 5,
    fill: "#6F6F6F"
  }, "Lorem ipsum")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-Copy-3",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 35,
    fill: "#6F6F6F"
  }, "Lorem ipsum")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-Copy-4",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 50,
    fill: "#6F6F6F"
  }, "Lorem ipsum")), /*#__PURE__*/React.createElement("text", {
    id: "Dolar-sit-amet",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 20,
    fill: "#000000"
  }, "Dolar sit amet")), /*#__PURE__*/React.createElement("text", {
    id: "Dolar-sit-amet-Copy-3",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 5,
    fill: "#000000"
  }, "Dolar sit amet")), /*#__PURE__*/React.createElement("text", {
    id: "Dolar-sit-amet-Copy",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 35,
    fill: "#000000"
  }, "Dolar sit amet")), /*#__PURE__*/React.createElement("text", {
    id: "Dolar-sit-amet-Copy-2",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 50,
    fill: "#000000"
  }, "Dolar sit amet")), /*#__PURE__*/React.createElement("line", {
    x1: 0.43220339,
    y1: 25.5,
    x2: 101.567797,
    y2: 25.5,
    id: "Line-4",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.43220339,
    y1: 10.5,
    x2: 101.567797,
    y2: 10.5,
    id: "Line-4-Copy-6",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.43220339,
    y1: 40.5,
    x2: 101.567797,
    y2: 40.5,
    id: "Line-4-Copy-4",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.43220339,
    y1: 55.5,
    x2: 101.567797,
    y2: 55.5,
    id: "Line-4-Copy-5",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/Columns.2d802d568250f083bbcbbc909e1584f5.svg";
export { ForwardRef as ReactComponent };